var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownloadArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 109.6 139.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#040000;stroke-linecap:round;stroke-linejoin:round;stroke-width:7px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_2",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1-2",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 54.8,
    y1: 48.67,
    x2: 54.8,
    y2: 90.43
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "73.44 72.56 54.8 91.2 36.16 72.56"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 36.16,
    y1: 103.86,
    x2: 73.44,
    y2: 103.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M99.45,136.47H10.15a6.65,6.65,0,0,1-6.65-6.65V10.15A6.65,6.65,0,0,1,10.15,3.5H73.89L106.1,35.71v94.11A6.65,6.65,0,0,1,99.45,136.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M106.1,35.71H80.54a6.65,6.65,0,0,1-6.65-6.65V3.5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadArrow);
export default __webpack_public_path__ + "static/media/download-arrow.f413d579ffee02195ef2bf8d24ba99d8.svg";
export { ForwardRef as ReactComponent };